(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dpr-sticky-buy"]) return;
  try {
    
if(!customElements.get('dpr-sticky-buy'))customElements.define('dpr-sticky-buy',class extends HTMLElement{
connectedCallback(){
 if(this.ready)return;this.ready=true;
 const plus=this.querySelector('button'),prices=JSON.parse(this.querySelector('[data-sticky-variants]').textContent);
 const getForm=()=>document.querySelector('product-info[id^="MainProduct-"] form[action*="/cart/add"]:not([id*="installment"])')||document.querySelector('.dual-interest form[action*="/cart/add"]');
 const getButton=form=>form?.querySelector('[name="add"],button[type="submit"]');
 let scheduled=false;
 const update=()=>{scheduled=false;const form=getForm(),button=getButton(form);if(!form||!button){this.hidden=true;return;}
 const rect=button.getBoundingClientRect();const blocked=!!document.querySelector('dialog[open],cart-drawer.active,cart-notification.active,details[open]>summary.header__icon');
 this.hidden=rect.bottom>=0||blocked;
 const id=new FormData(form).get('id'),variant=prices.find(v=>String(v.id)===String(id));
 plus.disabled=button.disabled||button.getAttribute('aria-disabled')==='true'||!variant;
 if(variant){const price=this.querySelector('[data-sticky-price]');if(price.textContent!==variant.price)price.textContent=variant.price;const img=this.querySelector('img');if(img&&img.getAttribute('src')!==variant.image){img.removeAttribute('srcset');img.src=variant.image;}}
 };
 const queue=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update);}};
 plus.addEventListener('click',()=>{const form=getForm(),button=getButton(form);if(!form||!button||plus.disabled)return;const invalid=[...form.elements].find(el=>el.willValidate&&!el.checkValidity());if(invalid){form.scrollIntoView({behavior:'smooth',block:'center'});invalid.focus({preventScroll:true});invalid.reportValidity();return;}button.click();queue();});
 this.abort=new AbortController();window.addEventListener('scroll',queue,{passive:true,signal:this.abort.signal});window.addEventListener('resize',queue,{signal:this.abort.signal});document.addEventListener('change',queue,{signal:this.abort.signal});
 this.observer=new MutationObserver(records=>{if(records.some(r=>!this.contains(r.target)))queue();});this.observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','disabled','aria-disabled','value','open']});update();
}
disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpradix-cro-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-variant-card]').forEach((card) => {
      const productCard = card.closest('.dpr-home__card');
      const image = productCard?.querySelector('.dpr-home__product-image');
      const selectedLabel = card.querySelector('.dpr-home__variant-selected [data-variant-label]');
      const swatches = card.querySelectorAll('.dpr-home__variant-swatch');

      if (!productCard || !image || !swatches.length) return;

      swatches.forEach((swatch) => {
        swatch.addEventListener('keydown', (event) => {
          if (event.key === ' ') {
            event.preventDefault();
            swatch.click();
          }
        });
        swatch.addEventListener('click', (event) => {
          event.preventDefault();
          swatches.forEach((item) => {
            item.classList.remove('is-selected');
            item.setAttribute('aria-pressed', 'false');
          });
          swatch.classList.add('is-selected');
          swatch.setAttribute('aria-pressed', 'true');
          const hasPhoto = Boolean(swatch.dataset.imageUrl);
          image.hidden = !hasPhoto;
          const photoNotice = productCard.querySelector('.dpr-home__photo-pending');
          if (photoNotice) photoNotice.hidden = hasPhoto;
          if (hasPhoto) image.src = swatch.dataset.imageUrl;
          image.removeAttribute('srcset');
          image.alt = swatch.dataset.imageAlt;
          const hoverImage = productCard.querySelector('.dpr-home__hover-image');
          if (hoverImage) {
            hoverImage.hidden = !swatch.dataset.hoverUrl;
            if (swatch.dataset.hoverUrl) {
              hoverImage.src = swatch.dataset.hoverUrl;
              hoverImage.removeAttribute('srcset');
              hoverImage.alt = swatch.dataset.imageAlt;
            }
          }
          const review = productCard.querySelector('.dpr-home__reviews');
          if (review && swatch.hasAttribute('data-review-count')) {
            const count = Number(swatch.dataset.reviewCount);
            review.hidden = !count;
            review.href = swatch.dataset.variantUrl + '#trustreviewsFrame';
            const rating = Math.min(5, Math.max(0, Number(swatch.dataset.reviewRating) || 0));
            review.querySelector('[data-review-stars]').style.width = (rating * 20) + '%';
            review.setAttribute('aria-label', rating + '/5 · ' + review.dataset.reviewTemplate.replace('[count]', count));
          }
          const quick = productCard.querySelector('.dpr-quick-cart');
          if (quick) {
            const input = quick.querySelector('input[name="id"]');
            const button = quick.querySelector('button[type="submit"]');
            input.value = swatch.dataset.quickId || '';
            button.disabled = !input.value || swatch.dataset.quickAvailable !== 'true';
            button.setAttribute('aria-label', button.title + ': ' + (swatch.dataset.imageAlt || swatch.dataset.variantLabel));
          }
          if (selectedLabel) selectedLabel.textContent = swatch.dataset.variantLabel;
          const price = productCard.querySelector('.dpr-home__price');
          if (price && swatch.dataset.variantPrice) price.textContent = swatch.dataset.variantPrice;
          productCard.querySelectorAll('.dpr-home__product-link').forEach((link) => {
            link.href = swatch.dataset.variantUrl;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpradix-hero-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dpr-swipe-hero'))customElements.define('dpr-swipe-hero',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.dpr-slider__track'),slides=[...track.querySelectorAll('[data-slide]')],dots=[...this.querySelectorAll('[data-dot]')];slides.forEach(s=>s.hidden=false);if(slides.length<2)return;this.querySelector('.dpr-slider__controls').hidden=false;let current=0,pointer=null,suppress=0;
const fit=()=>{if(matchMedia('(max-width:749px)').matches){track.style.height=Math.max(...slides.map(slide=>slide.offsetHeight))+'px';}else{track.style.removeProperty('height');}};
const update=()=>{current=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));dots.forEach((d,i)=>d.setAttribute('aria-pressed',String(i===current)));slides.forEach((s,i)=>{s.inert=i!==current;s.setAttribute('aria-hidden',String(i!==current));});this.querySelector('[data-status]').textContent=dots[current].getAttribute('aria-label')+' / '+slides.length;fit();};
const show=i=>track.scrollTo({left:((i+slides.length)%slides.length)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
dots.forEach((d,i)=>d.addEventListener('click',()=>show(i)));track.addEventListener('scroll',update,{passive:true});this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();show(current+(e.key==='ArrowRight'?1:-1));}});
track.addEventListener('dragstart',e=>e.preventDefault());track.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'||e.button!==0||e.target.closest('button,input,select,textarea'))return;pointer={id:e.pointerId,x:e.clientX,y:e.clientY,left:track.scrollLeft,index:current,drag:false};});
track.addEventListener('pointermove',e=>{if(!pointer||e.pointerId!==pointer.id)return;const dx=e.clientX-pointer.x,dy=e.clientY-pointer.y;if(!pointer.drag&&Math.abs(dx)>6&&Math.abs(dx)>Math.abs(dy)){pointer.drag=true;track.classList.add('is-dragging');track.setPointerCapture(e.pointerId);}if(pointer.drag){e.preventDefault();track.scrollLeft=pointer.left-dx;}});
const finish=(e,cancel=false)=>{if(!pointer||e.pointerId!==pointer.id)return;const p=pointer;pointer=null;if(track.hasPointerCapture(e.pointerId))track.releasePointerCapture(e.pointerId);track.classList.remove('is-dragging');if(p.drag){suppress=Date.now()+400;const dx=e.clientX-p.x;show(cancel?p.index:p.index+(Math.abs(dx)>40?(dx<0?1:-1):0));}};
track.addEventListener('pointerup',e=>finish(e));track.addEventListener('pointercancel',e=>finish(e,true));track.addEventListener('lostpointercapture',e=>finish(e,true));track.addEventListener('pointerleave',e=>{if(pointer&&!pointer.drag)pointer=null;});
track.addEventListener('click',e=>{if(Date.now()<suppress){e.preventDefault();e.stopImmediatePropagation();}},true);this.addEventListener('shopify:block:select',e=>{const i=slides.indexOf(e.target.closest('[data-slide]'));if(i>=0)show(i);});const observer=new ResizeObserver(fit);slides.forEach(s=>observer.observe(s));window.addEventListener('resize',()=>{track.scrollLeft=current*track.clientWidth;fit();});update();
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpradix-invicta-a-plus"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dpr-invicta-story')) {
  customElements.define('dpr-invicta-story', class extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!data?.variant) return;
          const id = String(data.variant.id);
          if (!this.querySelector('[data-aplus-variant="' + id + '"]')) return;
          this.querySelectorAll('[data-aplus-variant]').forEach(panel => {
            panel.hidden = panel.dataset.aplusVariant !== id;
          });
        });
      }
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpradix-localization"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-dpr-localization]');
  if (!root || window.Shopify?.designMode) return;
  const form = root.querySelector('form');
  if (!form) return;
  const readCookie = name => {
    const entry = document.cookie.split('; ').find(value => value.startsWith(name + '='));
    try { return entry ? decodeURIComponent(entry.slice(name.length + 1)) : ''; } catch { return ''; }
  };
  let preference = readCookie('dpr_locale_choice');
  if (!preference) {
    try { preference = localStorage.getItem('dpr_language_choice_v3') || ''; } catch {}
  }
  const [chosenCountry, chosenLanguage] = preference.split(':');
  const languages = root.dataset.languages.split(',');
  const country = root.dataset.country;
  const defaultLanguage = root.dataset.spanishCountries.split(',').includes(country) ? 'es' : 'en';
  const language = chosenCountry === country && languages.includes(chosenLanguage) ? chosenLanguage : defaultLanguage;
  if (!languages.includes(language) || root.dataset.language === language) return;
  const attempt = country + ':' + language;
  let lastAttempt = readCookie('dpr_locale_attempt');
  try { lastAttempt = sessionStorage.getItem('dpr_language_attempt_v3') || lastAttempt; } catch {}
  if (lastAttempt === attempt) return;
  const active = document.activeElement;
  if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return;
  try { sessionStorage.setItem('dpr_language_attempt_v3', attempt); } catch {}
  document.cookie = 'dpr_locale_attempt=' + encodeURIComponent(attempt) + '; Path=/; Max-Age=60; SameSite=Lax; Secure';
  form.querySelector('[name="language_code"]').value = language;
  let returnTo = form.querySelector('[name="return_to"]');
  if (!returnTo) {
    returnTo = document.createElement('input');
    returnTo.type = 'hidden';
    returnTo.name = 'return_to';
    form.appendChild(returnTo);
  }
  returnTo.value = window.location.pathname + window.location.search + window.location.hash;
  form.submit();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpradix-program"]) return;
  try {
    
if(!customElements.get('dpr-application')) customElements.define('dpr-application',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.querySelector('[data-add-social]')?.addEventListener('click',()=>{const box=this.querySelector('[data-socials]');const input=document.createElement('input');input.type='text';input.name='contact[social_'+(box.children.length+1)+']';input.setAttribute('aria-label',this.querySelector('[data-add-social]').getAttribute('aria-label'));box.append(input);input.focus();});
const form=this.querySelector('form'),steps=[...this.querySelectorAll('[data-step]')];
if(!form||!steps.length)return;
const back=this.querySelector('[data-back]'),next=this.querySelector('[data-next]'),submit=this.querySelector('[data-submit]'),status=this.querySelector('[data-step-status]');
let current=0;
const show=i=>{current=i;steps.forEach((s,j)=>s.hidden=i!==j);back.hidden=i===0;next.hidden=i===steps.length-1;submit.hidden=i!==steps.length-1;status.hidden=false;status.textContent=(i+1)+' / '+steps.length;};
const invalid=step=>[...step.querySelectorAll('input,select,textarea')].find(f=>!f.checkValidity());
const focusStep=()=>{const field=steps[current].querySelector('input,select,textarea');field?.focus();};
form.noValidate=true;
next.addEventListener('click',()=>{const field=invalid(steps[current]);if(field){field.reportValidity();return;}show(current+1);focusStep();});
back.addEventListener('click',()=>{show(Math.max(0,current-1));focusStep();});
form.addEventListener('submit',e=>{if(current<steps.length-1){e.preventDefault();next.click();return;}for(let i=0;i<steps.length;i++){const field=invalid(steps[i]);if(field){e.preventDefault();show(i);field.reportValidity();return;}}});
show(0);
}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpradix-promo-popup"] && !Shopify.designMode) return;
  try {
    
(()=>{const dialogs=document.querySelectorAll('[data-dpr-promo]');dialogs.forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const key='dpr-subscriber30-20260925';let prior=null;try{prior=localStorage.getItem(key);}catch(e){}let timer;const openOffer=(event)=>{if(event?.detail?.consent===true){const consent=dialog.querySelector('.dpr-promo__consent input');if(consent)consent.checked=true;}document.querySelector('cart-drawer.active')?.close();document.querySelector('cart-notification')?.close();if(!dialog.open)dialog.showModal();if(event?.detail?.consent===true)dialog.querySelector('input[type=email]')?.focus();};document.addEventListener('dpr:open-offer',openOffer);document.addEventListener('click',e=>{if(e.target.closest('[data-dpr-open-offer]'))openOffer();});const remember=()=>{try{localStorage.setItem(key,String(Date.now()));}catch(e){}};const close=()=>{remember();dialog.close();};dialog.querySelectorAll('[data-promo-close]').forEach(button=>button.addEventListener('click',close));dialog.querySelector('[data-promo-close-link]')?.addEventListener('click',close);dialog.addEventListener('cancel',remember);dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});const result=dialog.querySelector('[data-promo-result]');if(result&&typeof dialog.showModal==='function'){dialog.showModal();result.focus();remember();return;}if(prior&&Date.now()-Number(prior)<86400000)return;if(typeof dialog.showModal!=='function')return;const show=()=>{if(document.visibilityState!=='visible'||document.querySelector('dialog[open]'))return;dialog.showModal();remember();};if(location.pathname==='/'||location.pathname==='/en'||location.pathname==='/en/')timer=setTimeout(show,Number(dialog.dataset.delay)*1000);document.addEventListener('shopify:section:unload',()=>clearTimeout(timer),{once:true});});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
